/**
 * 子应用前缀
 */
export const CHILD_PREFIX = "app"

export const sysBelongConfig = {
  OrderCenter: "/orderCenter",
  Cdp: "/cdp",
  Advert: "/advert",
  CustomerCenter: "/customCenter",
  LogisticsCenter: "/logistics",
  MasterData: "/masterData",
  ProductCenter: "/product",
  SystemCount: "/count",
  WCT: "/userData",
  Voyager: "/voyager",
  Plm: "/plm",
  MaterialCenter: "/material",
  TA: "/ta"
}


/**
 * 子应用地址
 */
export const MICRO_APPS = {
  "//localhost:9005/": {
    name: "SystemCount",
    aliasName: "数据中心",
    testUrl: "https://page-system-data-center-test.tfeimall.com",
    graysUrl: "https://page-system-data-center-gray.tfeimall.com",
    url: `https://page-system-data-center.tfeimall.com`
  },
  "//localhost:9002/": {
    name: "WCT",
    aliasName: "WCT",
    testUrl: "https://page-wct-test.tfeimall.com",
    graysUrl: "https://page-wct-gray.tfeimall.com",
    url: `https://page-wct.tfeimall.com`
  },
  "//localhost:9001/": {
    name: "MasterData",
    aliasName: "主数据MDM",
    testUrl: "https://page-master-data-test.tfeimall.com",
    graysUrl: "https://page-master-data-gray.tfeimall.com",
    url: `https://page-master-data.tfeimall.com`
  },
  "//localhost:9003/": {
    name: "ProductCenter",
    aliasName: "商品中心",
    testUrl: `https://page-product-center-test.tfeimall.com`,
    graysUrl: `https://page-product-center-gray.tfeimall.com`,
    url: `https://page-product-center.tfeimall.com`
  },
  "//localhost:9004/": {
    name: "Advert",
    aliasName: "广告中心",
    testUrl: "https://page-advertising-center-test.tfeimall.com",
    graysUrl: "https://page-advertising-center-gray.tfeimall.com",
    url: `https://page-advertising-center.tfeimall.com`
  },
  "//localhost:9006/": {
    name: "Cdp",
    aliasName: "Cdp",
    testUrl: "https://page-cdp-test.tfeimall.com",
    graysUrl: "https://page-cdp-gray.tfeimall.com",
    url: `https://page-cdp.tfeimall.com`
  },
  "//localhost:9007/": {
    name: "CustomerCenter",
    aliasName: "客服中心",
    testUrl: "https://page-customer-center-test.tfeimall.com",
    graysUrl: "https://page-customer-center-gray.tfeimall.com",
    url: `https://page-customer-center.tfeimall.com`
  },
  "//localhost:9008/": {
    name: "OrderCenter",
    aliasName: "订单中心",
    testUrl: "https://page-order-center-test.tfeimall.com",
    graysUrl: "https://page-order-center-gray.tfeimall.com",
    url: `https://page-order-center.tfeimall.com`
  },
  "//localhost:9009/": {
    name: "LogisticsCenter",
    aliasName: "物流中心",
    testUrl: "https://page-logistics-center-test.tfeimall.com",
    graysUrl: "https://page-logistics-center-gray.tfeimall.com",
    url: `https://page-logistics-center.tfeimall.com`
  },
  "//localhost:9010/": {
    name: "Voyager",
    aliasName: "WCT_V2.0",
    testUrl: "https://voyager-test.tfeimall.com",
    graysUrl: "https://voyager-test.tfeimall.com",
    url: `https://page-voyager.tfeimall.com`
  },
  "//localhost:9011/": {
    name: "Plm",
    aliasName: "产品全生命周期管理",
    testUrl: "https://plm-test.tfeimall.com",
    graysUrl: "https://plm-test.tfeimall.com",
    url: `https://page-plm.tfeimall.com`
  },
  "//localhost:9012/": {
    name: "Material",
    aliasName: "素材中心",
    testUrl: "https://page-materia-center-test.tfeimall.com",
    graysUrl: "https://page-materia-center-test.tfeimall.com",
    url: `https://page-materia-center.tfeimall.com`
  },
  "//localhost:9013/": {
    name: "FinancialCenter",
    aliasName: "财务中心",
    testUrl: "https://page-financial-center-test.tfeimall.com",
    graysUrl: "https://page-financial-center-test.tfeimall.com",
    url: `https://page-financial-center.tfeimall.com`
  },
  "//localhost:9014/": {
    name: "SupplyChainManagement",
    aliasName: "供应链管理系统",
    testUrl: "https://page-supply-chain-management-test.tfeimall.com",
    graysUrl: "https://page-supply-chain-management-test.tfeimall.com",
    url: `https://page-supply-chain-management.tfeimall.com`
  },
  "//localhost:5173/": {
    name: "TA",
    aliasName: "TATA",
    testUrl: "https://page-say-all-test.tfeimall.com",
    graysUrl: "https://page-say-all-test.tfeimall.com",
    url: `https://page-say-all.tfeimall.com`
  }
}
export default function hostMap(host) {
  let url = host
  if (process.env.VUE_APP_ENV === "test") {
    url = MICRO_APPS[host]["testUrl"]
    if (process.env.VUE_APP_BASE_API === "https://gray.tfeimall.com") {
      url = MICRO_APPS[host]["graysUrl"]
    }
  } else if (process.env.VUE_APP_ENV === "production") {
    url = MICRO_APPS[host]["url"]
  }
  return url
}
/**
 * 全局资源
 */
export const GLOBAL_ASSETS = {
  js: [],
  css: []
}
